import React, { useLayoutEffect, useRef, useState } from "react"
import { Container } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import isNumeric from "validator/lib/isNumeric"
import isMobilePhone from "validator/lib/isMobilePhone"
import isEmpty from "validator/lib/isEmpty"
import { toast } from "react-toastify"
import jwtDecode from "jwt-decode"

import {
  getInitialRedirection,
  getUserAccesses,
  saveTokensInLocaleStorage
} from "utils"
import { Button, PageLoader, TextField } from "components"
import { updateUserAccountInfo } from "@redux"
import { getUserAccountInfo, signin } from "services"
import classes from "./index.module.scss"

const initialFormState = {
  input: "",
  password: ""
}

const Signin = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const isLoggedIn =
    !!localStorage.getItem("at")

  const initialShowLoadingState =
    isLoggedIn

  const [form, setForm] = useState(initialFormState)
  const [sending, setSending] = useState(false)
  const [formErrors, setFormErrors] = useState(initialFormState)
  const [showLoading, setShowLoading] = useState(initialShowLoadingState)

  const inputType = useRef("")

  const checkUserAccess = (initialRedirection) => {
    if (!!initialRedirection) return true

    localStorage.removeItem("at")

    localStorage.removeItem("rt")

    toast.error("شما دسترسی لازم برای ورود به این پنل را ندارید")

    return false
  }

  const validateRole = (role) => {
    if (role === "subscribeAdmin") return true

    setFormErrors(prev => ({
      ...prev,
      password: "شما اجازه دسترسی به این پنل را ندارید"
    }))

    setSending(false)

    return false
  }

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const validate = () => {
    const errors = { ...initialFormState }

    let result = true

    const isMobile = form.input.includes("+")

    if (isEmpty(form.input)) {
      errors.input = "شماره موبایل یا یوزرنیم الزامی است"
      result = false
    }

    if (isMobile) {
      inputType.current = "mobilePhone"

      if (!isMobilePhone(form.input, ["fa-IR", "ms-MY"], { strictMode: true })) {
        errors.input = "شماره موبایل صحیح نیست"
        result = false
      } else if (!isNumeric(form.input, { no_symbols: false })) {
        errors.input = "شماره موبایل صحیح نیست"
        result = false
      }
    } else {
      inputType.current = "username"
    }

    if (isEmpty(form.password)) {
      errors.password = "رمز عبور الزامی است"
      result = false
    }

    setFormErrors({ ...errors })

    return result
  }

  const sanitize = () => {
    const data = {
      [inputType.current]: form.input.trim(),
      password: form.password.trim()
    }

    return data
  }

  const handleSignin = async e => {
    e.preventDefault()

    if (!validate()) return

    setSending(true)
    try {
      const data = sanitize()

      const response = await signin(data, inputType.current)

      const { role } = jwtDecode(response["X-Access-Token"])

      if (!validateRole(role)) return

      saveTokensInLocaleStorage(
        response["X-Access-Token"],
        response["X-Refresh-Token"]
      )

      const {
        accessList,
        accessIds,
        ...userAccountDetails
      } = await getUserAccountInfo()

      const accesses = getUserAccesses(accessList)

      const initialRedirection =
        getInitialRedirection(accesses)

      if (!checkUserAccess(initialRedirection)) return

      dispatch(
        updateUserAccountInfo({
          ...userAccountDetails,
          accesses,
          role
        })
      )

      navigate(initialRedirection)
    } catch (err) {
      console.log(err)

      setSending(false)

      setFormErrors(prev => ({
        ...prev,
        password: "ورود انجام نشد"
      }))
    }
  }

  const autoRedirectUser = async () => {
    if (!isLoggedIn) return

    const {
      accessList,
      accessIds,
      ...userAccountDetails
    } = await getUserAccountInfo()

    const accesses = getUserAccesses(accessList)

    const initialRedirection =
      getInitialRedirection(accesses)

    if (!checkUserAccess(initialRedirection))
      return setShowLoading(false)

    dispatch(
      updateUserAccountInfo({
        ...userAccountDetails,
        accesses
      })
    )

    navigate(initialRedirection, { replace: true })
  }

  useLayoutEffect(() => {
    autoRedirectUser()
  }, [])

  if (showLoading) return <PageLoader />

  return (
    <div className={classes["container"]}>
      <Container>
        <div className={classes["wrapper"]}>
          <div className={classes["card"]}>
            <div className={classes["title"]}>
              <h3 className={classes["text"]}>
                ورود
              </h3>
            </div>

            <form
              onSubmit={handleSignin}
              className={classes["main"]}
            >
              <div className={classes["inputs"]}>
                <TextField
                  withoutSpace
                  className={classes["input"]}
                  label="شماره موبایل و یوزرنیم"
                  placeholder="شماره موبایل یا یوزرنیم را وارد کنید"
                  error={formErrors.input}
                  value={form.input}
                  onChange={(e) => handleChange(e.target.value, "input")}
                />

                <TextField
                  isPassword
                  label="رمز عبور"
                  type="password"
                  placeholder="رمز عبور خود را وارد کنید"
                  error={formErrors.password}
                  value={form.password}
                  onChange={(e) => handleChange(e.target.value, "password")}
                />
              </div>
              <div className={classes["footer"]}>
                <Button
                  className={classes["button"]}
                  loading={sending}
                >
                  ورود
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Signin